import {StringUtils} from "./string-utils";

export class DateUtils {

  private static MILLISECONDS: number = 1000;
  private static SECONDS: number = 60;
  private static OFFSET_MINUTE: number = DateUtils.MILLISECONDS * DateUtils.SECONDS;

  public static formatDisplay(input: Date): Date {
    if (input) {
      return DateUtils.updateValue(input, 1);
    } else {
      return null!;
    }
  }

  private static updateValue(input: Date, multiplier: number): Date {
    let formatted = new Date();
    let formattedInput = new Date(input);
    formatted.setTime(formattedInput.getTime() + formattedInput.getTimezoneOffset() * multiplier * DateUtils.OFFSET_MINUTE);
    return formatted;
  }

  public static formatOutput(value: Date): Date {
    if (value) {
      return DateUtils.updateValue(value, -1);
    } else {
      return null!;
    }
  }

  public static formatPostedDate(input: Date): string {
    if (input) {
      let monthValue: string = DateUtils.leftPad((input.getMonth() + 1).toString(), 2);
      let dayValue: string = DateUtils.leftPad(input.getDate().toString(), 2);
      let yearValue: string = input.getFullYear().toString();
      return monthValue + '/' + dayValue + '/' + yearValue;
    } else {
      return "";
    }
  }

  public static parseDate(input: string): Date {
    if (StringUtils.isNotBlank(input)) {
      const datePattern = new RegExp('^(\\d{4}-[01]?[0-9]-[0123]?[0-9])|([01]?[0-9]\\/[0123]?[0-9]\\/\\d{4})$');
      if (input.match(datePattern)) {
        return new Date(input);
      }
    }
    return undefined!;
  }

  private static leftPad(input: string, length: number): string {
    let output: string = input;
    while (output.length < length) {
      output = '0' + output;
    }
    return output;
  }

}
